import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

import { instance } from "@/api/apiInstances/apiInstance.js";
import {
  startClockIn,
  endClockIn,
  startBreak,
  endBreak,
  startPrivateExit,
  endPrivateExit,
  startFieldWork,
  endFieldWork,
  myCurrentPresence,
} from "@/api/apiRequests/myPresenceApi.js";

const defaultAvatarImage =
"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNjAwIDYwMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgc3R5bGU9ImZpbGw6I2UyZTNlNTsiLz48Y2lyY2xlIGN4PSIzMDAiIGN5PSIzMDAiIHI9IjE1NSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2Utd2lkdGg6NDdweDtzdHJva2U6I2JjYmRiZjsiLz48cmVjdCB4PSIxNjAiIHk9IjIyMyIgd2lkdGg9IjI3NSIgaGVpZ2h0PSIxNjYiIHN0eWxlPSJmaWxsOiNlM2U1ZTQ7Ii8+PHBhdGggZD0iTTQ0MC41LDM5NC41bC0yODYsMGwwLC0xNzdsMjg2LDBsMCwxNzdaTTE2NS41LDIyOC41bDAsMTU1bDI2NCwwbDAsLTE1NWwtMjY0LDBaIiBzdHlsZT0iZmlsbDojZmZmOyIvPjxwYXRoIGQ9Ik00MDQuNDM0LDE3MC44NzdsLTIzMi45NCwyMzIuOTQxbDM1LjM1NSwzNS4zNTVsMjMyLjk0MSwtMjMyLjk0bC0zNS4zNTYsLTM1LjM1NloiIHN0eWxlPSJmaWxsOiNiY2JkYmY7Ii8+PC9zdmc+";
const defaultImage =
"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNjAwIDYwMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgc3R5bGU9ImZpbGw6I2UyZTNlNTsiLz48Y2lyY2xlIGN4PSIzMDAiIGN5PSIzMDAiIHI9IjE1NSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2Utd2lkdGg6NDdweDtzdHJva2U6I2JjYmRiZjsiLz48cmVjdCB4PSIxNjAiIHk9IjIyMyIgd2lkdGg9IjI3NSIgaGVpZ2h0PSIxNjYiIHN0eWxlPSJmaWxsOiNlM2U1ZTQ7Ii8+PHBhdGggZD0iTTQ0MC41LDM5NC41bC0yODYsMGwwLC0xNzdsMjg2LDBsMCwxNzdaTTE2NS41LDIyOC41bDAsMTU1bDI2NCwwbDAsLTE1NWwtMjY0LDBaIiBzdHlsZT0iZmlsbDojZmZmOyIvPjxwYXRoIGQ9Ik00MDQuNDM0LDE3MC44NzdsLTIzMi45NCwyMzIuOTQxbDM1LjM1NSwzNS4zNTVsMjMyLjk0MSwtMjMyLjk0bC0zNS4zNTYsLTM1LjM1NloiIHN0eWxlPSJmaWxsOiNiY2JkYmY7Ii8+PC9zdmc+";

const noActivePresenceColor = "#5f6281";
const baseUrl = process.env.VUE_APP_BASE_URL.replace(/\/$/, '');// Remove the trailing slash if it exists

export default new Vuex.Store({
  state: {
    loginCouter: 0,
    layout: {
      navPos: "top", //top, bottom, left, right, false
      toolbar: "top", //top, bottom, false
      footer: true, //above, below, false
      boxed: false, //true, false
      roundedCorners: false, //true, false
      viewAnimation: "fade-top", // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
    },
    logged: null,
    token: null,
    currentPresenceColor: noActivePresenceColor,//starting color for the clock icon next to presence in navbar
    refreshPresenceDataCounter: 0,
    presence: {
      Work: null,
      Break: null,
      "Private exit": null,
      "Field work": null,
    },
    presenceLoadingOption: null,
    presenceTypes: [
      { id: 1, name: "Work", transKey: 'work', color: "#2786fb", positionForDisplay: 1 },
      { id: 2, name: "Paid Break", transKey: 'paid_break', color: "#1dc9b7", positionForDisplay: 2 },
      { id: 3, name: "Private exit", transKey: 'private_exit', color: "#ffb822", positionForDisplay: 13 },
      { id: 4, name: "Absence", transKey: 'absence', color: "#32c809", positionForDisplay: 4 },
      { id: 5, name: "Field work", transKey: 'field_work', color: "purple", positionForDisplay: 3 },
      { id: 6, name: "Unauthorized Absence", transKey: 'unauth_absence', color: "red", positionForDisplay: 14, },
      { id: 7, name: "Presence On Holiday", transKey: 'presence_on_holiday', color: "#2786fb", positionForDisplay: 11,},
      { id: 8, name: "Presence On Absence", transKey: 'presence_on_absence', color: "#2786fb", positionForDisplay: 10,},
      { id: 9, name: "Holiday", transKey: 'holiday', color: "#32c809", positionForDisplay: 5 },
      { id: 10, name: "Break on holiday", transKey: 'break_on_holiday', color: "#1dc9b7" },
      { id: 11, name: "Break on absence", transKey: 'break_on_absence', color: "#1dc9b7" },
      { id: 12, name: "Field work on holiday", transKey: 'field_work_on_holiday', color: "purple" },
      { id: 13, name: "Field work on absence", transKey: 'field_work_on_absence', color: "purple" },
      { id: 14, name: "Presence On Rest Day", transKey: 'presence_on_rest_day', color: "#2786fb", positionForDisplay: 12,},
      { id: 15, name: "Field work on rest day", transKey: 'field_work_on_rest_day', color: "purple" },
      { id: 16, name: "Break on rest day", transKey: 'break_on_rest_day', color: "#1dc9b7" },
      { id: 17, name: "Presence on night work", transKey: 'presence_on_night_work', color: "#2786fb", positionForDisplay: 9,},
      { id: 18, name: "Field work on night work", transKey: 'field_work_on_night_work', color: "purple" },
      { id: 19, name: "Break on night work", transKey: 'break_on_night_work', color: "#1dc9b7" },
      { id: 20, name: "Exceeded Break", transKey: 'exceeded_break', color: "#fd397a", positionForDisplay: 15,},
      { id: 21, name: "Overtime work", transKey: 'overtime_work', color: "#2786fb", positionForDisplay: 8 },
      { id: 22, name: "Unpaid Absence", transKey: 'unpaid_absence', color: "#32c809", positionForDisplay: 16, },
      { id: 23, name: "Rest Day", transKey: 'rest_day', color: "lightgreen", positionForDisplay: 17 },
      { id: 24, name: "Scheduled time", transKey: 'scheduled_time', color: "#b5b9bd", positionForDisplay: 7,},
      { id: 25, name: "Total regular time", transKey: 'total_regular_time',  color: "grey", positionForDisplay: 6, },
      { id: 26, name: "Description", transKey: 'description', color: "grey" },
      { id: "empty", name: "", transKey: '', color: "lightgrey" },
    ],
    absences: {
      1: { name: "Vacation", transKey: "vacation", },
      2: { name: "Personal days", transKey: "presonal_days", },
      3: { name: "Sick leave", transKey: "sick_leave", },
      4: { name: "Business trip", transKey: "business_trip", },
      5: { name: "Work from home", transKey: "work_from_home", },
      6: { name: "Extra days", transKey: "extra_days", },
      7: { name: "Switched day", transKey: "switched_day", },
      8: { name: "Paid parental leave", transKey: "paid_patental_leave", },
      9: { name: "Unpaid parental leave", transKey: "unpaid_patental_leave", },
      10:{ name: "Unpaid leave", transKey: "unpaid_leave", },
      11:{ name: "Rest day", transKey: "rest_day", },
    },
    personalDays:{
      1: { name: 'For making a marriage', transKey: "marriage",},
      2: { name: 'For the marriage of a child', transKey: "child_marriage", },
      3: { name: 'For the birth or adoption of a child', transKey: "adoption_child", },
      4: { name: 'For the death of a spouse or child', transKey: "death_spouse_child", },
      5: { name: 'For the death of a parent, brother, sister', transKey: "death_parent_brother_sister", },
      6: { name: 'For the death of a parent of a spouse', transKey: "death_parent_spouse", },
      7: { name: 'For the death of a grandfather or grandmother', transKey: "death_grandfather_grandmother", },
      8: { name: 'For taking an expert or other exams for the needs of the employer', transKey: "needs_of_employer", },
      9: { name: 'For natural disasters', transKey: "natural_disasters", },
      10:{ name: 'For moving the family from one place to another', transKey: "moving_family_from_one_to_another_place", },
      11:{ name: 'For moving the family to the same place', transKey: "moving_family_to_the_same_place", },
    },

    user: {
      termsAndConditionsAccepted: false,
      changePasswordRequired: false,
    },
    showChangePasswordModal: false,
    passwordExpired: false,
    avatarImage: defaultAvatarImage,
    defaultPresenceImage: defaultImage,
    isCurrentWeek: false,

    cookiesAccepted: false,
    defaultImageUser: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNjAwIDYwMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgc3R5bGU9ImZpbGw6I2UyZTNlNTsiLz48Y2lyY2xlIGN4PSIzMDAiIGN5PSIzMDAiIHI9IjE1NSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2Utd2lkdGg6NDdweDtzdHJva2U6I2JjYmRiZjsiLz48cmVjdCB4PSIxNjAiIHk9IjIyMyIgd2lkdGg9IjI3NSIgaGVpZ2h0PSIxNjYiIHN0eWxlPSJmaWxsOiNlM2U1ZTQ7Ii8+PHBhdGggZD0iTTQ0MC41LDM5NC41bC0yODYsMGwwLC0xNzdsMjg2LDBsMCwxNzdaTTE2NS41LDIyOC41bDAsMTU1bDI2NCwwbDAsLTE1NWwtMjY0LDBaIiBzdHlsZT0iZmlsbDojZmZmOyIvPjxwYXRoIGQ9Ik00MDQuNDM0LDE3MC44NzdsLTIzMi45NCwyMzIuOTQxbDM1LjM1NSwzNS4zNTVsMjMyLjk0MSwtMjMyLjk0bC0zNS4zNTYsLTM1LjM1NloiIHN0eWxlPSJmaWxsOiNiY2JkYmY7Ii8+PC9zdmc+",

  },

  getters: {
    defaultImageUser: state => state.defaultImageUser,
    transformedPresenceTypes(state) {
      // Returns an object where the keys are presence type IDs 
      // and the values are the corresponding presence types.
      return state.presenceTypes.reduce((acc, presenceType) => {
        acc[presenceType.id] = presenceType;
        return acc;
      }, {});
    },
    showSaturday: (state, getters) => state.user.showSaturday,
    showSunday: (state, getters) => state.user.showSunday,
    showUserHistory: (state, getters) => state.user.showUserHistory,
    loginCouter:(state, getters) => state.loginCouter,
    token:(state, getters) => state.token,
    refreshPresenceDataCounter:(state, getters) => state.refreshPresenceDataCounter,
    absences:(state,getters) => state.absences,
    personalDays:(state,getters) => state.personalDays,
    termsAndConditionsAccepted: (state, getters) => state.user.termsAndConditionsAccepted,
    changePasswordRequired: (state, getters) => state.user.changePasswordRequired,
    showChangePasswordModal: (state, getters) => state.showChangePasswordModal,
    passwordExpired: (state, getters) => state.passwordExpired,
    user: (state, getters) => state.user,
    userId: (state, getters) => state.user.id,
    qrCode: (state, getters) => state.user.qrCode || defaultAvatarImage,
    username: (state, getters) => state.user.username,
    userColor: (state, getters) => state.user.color,
    roleName: (state, getters) => state.user.roleName,
    companyName: (state, getters) => state.user.companyName,
    showQR: (state, getters) => state.user.showQR,
    teamLeadShiftAction: (state, getters) => state.user.teamLeadShiftAction,
    presenceTypes: (state, getters) => state.presenceTypes,
    isCurrentWeek: (state, getters) => state.isCurrentWeek,
    cookiesAccepted:(state,getters) => state.cookiesAccepted,

    layout(state, getters) {
      return state.layout;
    },
    navPos(state, getters) {
      return state.layout.navPos;
    },
    toolbar(state, getters) {
      return state.layout.toolbar;
    },
    footer(state, getters) {
      return state.layout.footer;
    },
    boxed(state, getters) {
      return state.layout.boxed;
    },
    roundedCorners(state, getters) {
      return state.layout.roundedCorners;
    },
    viewAnimation(state, getters) {
      return state.layout.viewAnimation;
    },
    isLogged(state, getters) {
      return state.logged;
    },
    presence(state, getters) {
      return state.presence;
    },
    presenceLoadingOption(state, getters) {
      return state.presenceLoadingOption;
    },
    currentPresenceColor(state, getters) {
      return state.currentPresenceColor;
    },
    getCalendarData(state, getters) {
      return state.calendarData;
    },
    getAvatarImage(state, getters) {
      return state.avatarImage;
    },
    getPresenceImage(state, getters) {
      return state.defaultPresenceImage;
    },
  },

  mutations: {
    incrementloginCouter(state){
      state.loginCouter++;
    },
    //resetloginCouter(state){
    //  state.loginCouter = 0;
    //},
    setToken(state, payload){
      state.token = payload;
    },
    IncreaseRefreshPresenceDataCounter(state) {
      state.refreshPresenceDataCounter++;
    },
    setShowChangePasswordModal(state, value) {
      state.showChangePasswordModal = value;
    },
    setPasswordExpired(state, isExpired) {
      state.passwordExpired = isExpired;
    },
    setUser: (state, user) => {
      //console.log('setUser', user);
      state.user = {
        id: user.id,
        username: user.full_name,
        departmentId: user.department_id,
        roleId: user.roles[0].id,
        companyId: user.company_id,
        teamId: user.team_id,
        color: user.user_color,
        roleName: user.roles[0].name,
        companyName: user.company.name,
        companyCreatedAt: user.company.created_at,
        termsAndConditionsAccepted: user.terms_conds,
        showQR: user.company.show_qr_on_web,
        qrCode: user.qr_code,
        teamLeadShiftAction: user.company.TL_shift_action,
        showSaturday: user.company.show_saturday,
        showSunday: user.company.show_sunday,
        showUserHistory: user.company.show_user_history,
      };
    },
    setLayout(state, payload) {
      if (payload && payload.navPos !== undefined)
        state.layout.navPos = payload.navPos;

      if (payload && payload.toolbar !== undefined)
        state.layout.toolbar = payload.toolbar;

      if (payload && payload.footer !== undefined)
        state.layout.footer = payload.footer;

      if (payload && payload.boxed !== undefined)
        state.layout.boxed = payload.boxed;

      if (payload && payload.roundedCorners !== undefined)
        state.layout.roundedCorners = payload.roundedCorners;

      if (payload && payload.viewAnimation !== undefined)
        state.layout.viewAnimation = payload.viewAnimation;
    },
    setTermsAndConditionsAccepted(state, payload) {
      state.user.termsAndConditionsAccepted = true;
    },
    setChangePasswordRequired(state, payload) {
      state.user.changePasswordRequired = true;
    },
    setLogin(state, payload) {
      state.logged = true;
    },
    setLogout(state, payload) {
      state.layout.navPos = null;
      state.layout.toolbar = null;
      state.showChangePasswordModal= false;
      state.passwordExpired= false;
      
      state.token = null;
      state.logged = false;
      state.user = {
        username: "",
        roleName:"",
        companyName:"",
        id: "",
        showQR:"",
      }

      state.avatarImage = defaultAvatarImage;

      //Reset presence:
      state.presence.Work = null;
      state.presence.Break = null;
      state.presence["Private exit"] = null;
      state.presence["Field work"] = null;
    },
    setPresence(state, payload) {
      // change the state of the clicked option
      // and change everything else to false
      // console.log("imame payload", payload)
      if (payload) {
        for (let property in state.presence) {
          if (payload.includes(property)) {
            state.presence[property] = !state.presence[property];
          } else {
            state.presence[property] = false;
          }
        }
      }
    },
    setResetPresence(state) {
      // reset the buttons state
        for (let property in state.presence) {
          state.presence[property] = false;
        }
    },
    setPresenceLoadingOption(state, payload){
      state.presenceLoadingOption = payload;
      // console.log("Loading Status:", state.presenceLoadingOption)
    },
    setCurrentPresenceColor(state, payload) {
      state.currentPresenceColor = payload;
    },

    setCalendarData(state, data) {
      state.calendarData = [...state.calendarData, data];
    },

    updateAvatarImage(state, link) {
      //state.avatarImage = `http://api-absent2.sentice.com${link}?${new Date().getTime()}`;
      state.avatarImage = link;
    },

    setIsCurrentWeek: (state, payload) => {
      state.isCurrentWeek = payload;
    },

    cookiesAccepted: (state, payload) => {
      state.cookiesAccepted = true;
    },
  },

  actions: {
    // Get the current presence state for today's buttons
    fetchMyCurrentPresence({ commit, getters }) {
      // console.log("fetchMyCurrentPresence enter")
      if (getters.isLogged && getters.token) {
        myCurrentPresence(instance)
          .then((response) => {
            // console.log("myCurrentPresence Response:", response);
            commit("setResetPresence") // reset the state

            //if true, the user has an active presence
            if (response.data.length > 0) {
              const presenceTypeId = response.data[0].presence_type_id;
              const presenceTypes = getters.presenceTypes;
              let matchedPresenceType = presenceTypes.find(
                (type) => type.id === presenceTypeId
              );

              if (matchedPresenceType) {
                //if the presenceType is Presence On Holiday/Absence/Rest Day/Night
                if ([7, 8, 14, 17].includes(presenceTypeId)) {
                  //set it to type "Work" so that the Work (Clock Out) button can be active
                  matchedPresenceType = presenceTypes[0];
                  //console.log('matchedPresecnceType = ', matchedPresenceType);
                }
                commit("setPresence", matchedPresenceType.name);
                commit("setCurrentPresenceColor", matchedPresenceType.color);
                //console.log("presence set to:", matchedPresenceType.name);
              }
            } else {
              // console.log("setCurrentPresenceColor empty")
              commit("setCurrentPresenceColor", noActivePresenceColor);
            }
          })
          .catch((error) => {
            // console.error(error);
          });
      }
    },

    setPresenceAction({ commit, state }, option) {
      return new Promise((resolve, reject) => {
        commit("setPresence", option);
        commit("setPresenceLoadingOption", option);
        const presence = state.presence;
    
        let actionPromise;
        let actionMessage;

        switch (option) {
          case "Work":
            if (presence["Work"]) {
              actionPromise = startClockIn(instance);
              actionMessage = "Start Clock Response:";
              commit("setCurrentPresenceColor", state.presenceTypes[0].color);
            } else {
              actionPromise = endClockIn(instance);
              actionMessage = "End Clock Response:";
              commit("setCurrentPresenceColor", noActivePresenceColor);
            }
            break;
          case "Break":
            if (presence["Break"]) {
              actionPromise = startBreak(instance);
              actionMessage = "Start Break Response:";
              commit("setCurrentPresenceColor", state.presenceTypes[1].color);
            } else {
              actionPromise = endBreak(instance);
              actionMessage = "End Break Response:";
              commit("setCurrentPresenceColor", noActivePresenceColor);
            }
            break;
          case "Private exit":
            if (presence["Private exit"]) {
              actionPromise = startPrivateExit(instance);
              actionMessage = "Start Private Exit Response:";
              commit("setCurrentPresenceColor", state.presenceTypes[2].color);
            } else {
              actionPromise = endPrivateExit(instance);
              actionMessage = "End Private Exit Response:";
              commit("setCurrentPresenceColor", noActivePresenceColor);
            }
            break;
          case "Field work":
            if (presence["Field work"]) {
              actionPromise = startFieldWork(instance);
              actionMessage = "Start Field Work Response:";
              commit("setCurrentPresenceColor", state.presenceTypes[4].color);
            } else {
              actionPromise = endFieldWork(instance);
              actionMessage = "End Field Work Response:";
              commit("setCurrentPresenceColor", noActivePresenceColor);
            }
            break;
          default:
            reject("Invalid option");
            break;
        }

        if (actionPromise) {
          actionPromise
            .then((response) => {
              // console.log(actionMessage, response);
              commit("IncreaseRefreshPresenceDataCounter");
              resolve(response); // Resolve the Promise with the response
            })
            .catch((error) => {
              // console.error(error);
              reject(error); // Reject the Promise with the error
            }).finally (() =>{
             commit("setPresenceLoadingOption", null);

            });
        } else {
          reject("Action promise not defined");
        } 
      });
    }
  },

  plugins: [
    createPersistedState({
      paths: ["layout", "logged", "username","roleName","companyName","user", "token", "avatarImage","showChangePasswordModal","passwordExpired"],
    }),
  ],
  strict: debug,
});